import { HashRouter, Navigate, Route, Routes } from "react-router";
import { HomeScreen } from "../screens/HomeScreen.tsx";
import { WordsScreen } from "../screens/WordsScreen.tsx";
import { AddWordScreen } from "../screens/AddWordScreen.tsx";
import { ChooseMeaningsScreen } from "../screens/ChooseMeaningsScreen.tsx";
import { ReviewMeaningsScreen } from "../screens/ReviewMeaningsScreen.tsx";
import { SavedMeaningsScreen } from "../screens/SavedMeaningsScreen.tsx";
import { MeaningCardScreen } from "../screens/MeaningCardScreen.tsx";
import { EditMeaningScreen } from "../screens/EditMeaningScreen.tsx";
import { PracticeSetupScreen } from "../screens/PracticeSetupScreen.tsx";
import { PracticeOptionsScreen } from "../screens/PracticeOptionsScreen.tsx";
import { PracticeSelectScreen } from "../screens/PracticeSelectScreen.tsx";
import { PracticeSessionScreen } from "../screens/PracticeSessionScreen.tsx";
import { PracticeSummaryScreen } from "../screens/PracticeSummaryScreen.tsx";
import { SettingsScreen } from "../screens/SettingsScreen.tsx";
import { ImportScreen } from "../screens/ImportScreen.tsx";
import { Frame, Screen, TopBar } from "../components/Shell.tsx";
import styles from "../design-system/ui.module.css";

function Missing() {
  return (
    <Frame>
      <Screen withNav={false}>
        <TopBar title="Vocably" backTo="/" />
        <div className={styles.empty}>That page is not available. Return home and try again.</div>
      </Screen>
    </Frame>
  );
}

export function AppRoutes() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/words" element={<WordsScreen />} />
        <Route path="/words/:wordId" element={<SavedMeaningsScreen />} />
        <Route path="/meanings/:meaningId" element={<MeaningCardScreen />} />
        <Route path="/meanings/:meaningId/edit" element={<EditMeaningScreen />} />
        <Route path="/add" element={<AddWordScreen />} />
        <Route path="/add/choose" element={<ChooseMeaningsScreen />} />
        <Route path="/add/review" element={<ReviewMeaningsScreen />} />
        <Route path="/practice" element={<PracticeSetupScreen />} />
        <Route path="/practice/setup" element={<PracticeOptionsScreen />} />
        <Route path="/practice/select" element={<PracticeSelectScreen />} />
        <Route path="/practice/session" element={<PracticeSessionScreen />} />
        <Route path="/practice/summary" element={<PracticeSummaryScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/import" element={<ImportScreen />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Missing />} />
      </Routes>
    </HashRouter>
  );
}
